import { Box, FormLabel } from '@mui/material';
import React from 'react';
import { PrettoSlider } from '../../assets/styles/styles';
type Props = {
  formData: {
    stability: number;
    similarity_boost: number;
    style: number;
    use_speaker_boost: boolean;
  };
  onChange: (
    event: Event | React.InputHTMLAttributes<HTMLInputElement>,
  ) => void;
};

const Groq = ({ formData, onChange }: Props) => {
  const flexColumnStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
  };

  const makePercentage = (value: number) => {
    return Math.round(value * 100);
  };

  return (
    <Box mt={'12px'}>
      
    </Box>
  );
};

export default Groq;
